module.exports = __webpack_public_path__ + "static/media/logo.909aed91.svg";